
const spacingFunction = (gridStyle) => {
  return (width) => {
    if (width < 768) {
      return gridStyle.spacing.laptop * 0.7;
    } else {
      return gridStyle.spacing.laptop;
    }
  };
};
const columnFunction = (gridStyle) => (containerWidth) => {
  if (containerWidth < 400) return gridStyle.columns.laptop - 2;
  if (containerWidth < 800) return gridStyle.columns.laptop - 1;
  return gridStyle.columns.laptop;
};

const targetRowHeightFunction = (gridStyle) => (containerWidth) => {
  if (containerWidth < 400) return gridStyle.targetRowHeight.laptop * 0.6;
  if (containerWidth < 800) return gridStyle.targetRowHeight.laptop * 0.9;
  return gridStyle.targetRowHeight.laptop;
};

const createGridFunctions = (gridStyle) => {
  const props = {};
  if (gridStyle.spacing) {
    props.spacing = spacingFunction(gridStyle);
  }
  if (gridStyle.columns) {
    props.columns = columnFunction(gridStyle);
  }
  if (gridStyle.targetRowHeight) {
    props.targetRowHeight = targetRowHeightFunction(gridStyle);
  }
  return props;
};



const getActivityKey = ({
  type,
  imageId,
  requestId,
  sponsorId,
  playerId: playerId = null,
  eventId,
}) => {
  let unique_key = `visit_${type}_${eventId}`;
  if (imageId) {
    unique_key += `_${imageId}`;
  }
  if (requestId) {
    unique_key += `_${requestId}`;
  }
  if (sponsorId) {
    unique_key += `_${sponsorId}`;
  }
  if (playerId) {
    unique_key += `_${playerId}`;
  }
  return unique_key;
};

export { createGridFunctions, getActivityKey };
